export default {
  computed: {
    user() {
      return this.$store.state.user;
    },
    instructions() {
      return this.$store.state.news.instructions;
    },
    loading() {
      return this.$store.state.loading;
    },
  },
  methods: {
    getPublication(id) {
      this.$router.push(`/instruction/${id}`);
    },
  },
  created() {
    this.$store.dispatch('news/GetInstructions');
  },
};
